import React from 'react'
import styled from 'styled-components/macro'

import { TransparentButton } from '../Buttons'
import { CloseIcon } from '../../../Assets'
import {
  Layer as DefaultLayer,
  Modal as DefaultModal,
} from './defaultComponents'
import { getCustomComponents } from '../../PatientUpload/common/Themes'


interface CloseButtonPositionProps {
  right?: string
  top?: string
}
interface ModalLayerProps {
  toggleModal?: (value: boolean) => void
  modalStyles?: string
  layerStyles?: string
  showCloseButton?: boolean
  customerTheme?: string
  closeButtonPosition?: CloseButtonPositionProps | null
}

const defaultComponents = {
  Layer: DefaultLayer,
  Modal: DefaultModal,
}

export const ModalLayer: React.FunctionComponent<ModalLayerProps> = ({
  toggleModal = () => {},
  children,
  modalStyles,
  layerStyles,
  showCloseButton,
  customerTheme = '',
  closeButtonPosition = {}
}) => {
  const { Modal, Layer } = {
    ...defaultComponents,
    ...getCustomComponents(customerTheme),
  }

  return (
    <Layer styles={layerStyles}>
      <Modal autoFocus styles={modalStyles} role="dialog">
        {showCloseButton && (
          <StyledButton
            onClick={() => toggleModal(false)}
            aria-label="Close the modal"
            name="closeModal"
            right={closeButtonPosition?.right}
            top={closeButtonPosition?.top}
          >
            <img src={CloseIcon} alt="Close modal icon" />
          </StyledButton>
        )}
        {children}
      </Modal>
    </Layer>
  )
}

interface CloseButtonPosition {
  right?: string
  top?: string
}

const StyledButton = styled(TransparentButton)<CloseButtonPosition>`
  position: absolute;
  top: ${({ top }) => top || '10px'};
  right: ${({ right }) => right || '10px'};
  width: 25px;
  background-color: transparent;
  z-index: 2;
`

export const ModalStyles = `
  padding: 1.5rem;
  radius: 1rem;
  max-width: none;
  width: 500px;
  justify-content: flex-start;
`

export const OverflowModalStyles=`
  padding: 1.5rem;
  radius: 1rem;
  max-width: none;
  width: 500px;
  justify-content: flex-start;
  overflow-y: visible;
`
